<template>
  <div class="welcome reading">
    <div class="fold">
      <figure class="banner">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" v-bind:class="'logo'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g data-name="Warstwa 3"><g data-name="Icon Big"><path fill="currentColor" d="M207.6 192.9c.28-1.46 3.45-3.78 7.05-5.15l14.81-5.64c3.6-1.37 3.41-2.88-.41-3.36L214.5 177c-3.82-.47-7.66-3.06-8.52-5.74s-3.21-12-1.77-15.53l8.73-21.56c1.45-3.57.13-4.58-2.93-2.24l-17.33 13.25c-3.06 2.34-6.82 3.65-8.36 2.91l-2.13-.73-4.5-1.53c-2.8-.25-7.48-2.51-10.41-5a19.57 19.57 0 00-4-3.9c-2.67-2-2.9-1.21-.51 1.81l.91 1.15c2.39 3 3.6 5.73 2.68 6s-7.33-.86-11-2.1l-9.55-3.24c-3.64-1.24-6 .83-5.22 4.6l.59 2.88c.77 3.77.48 7.7-.65 8.74s-6.83 4.88-10.55 5.85l-.71.19c-3.72 1-4.51 2.43-1.75 3.23a4.66 4.66 0 013.25 6.15c-1 2.58-4.53 12-7.49 14.49l-7.53 6.28c-3 2.46-2.26 4.89 1.56 5.4l7.42 1c3.82.5 8.17 3.13 9.67 5.85s6.81 11.9 6.81 15.75v2.87c0 3.85 2.27 4.81 5 2.14l.18-.17c2.78-2.67 6.79-4.19 8.93-3.37s10.3 4.29 13 7.08l6.5 6.85c2.65 2.8 5.59 2 6.54-1.7l1.68-6.58a20.76 20.76 0 017.6-10.6l7.81-7c2.45-3 6.94-5.9 10-6.5s10.13-3.17 6.37-4l-1.78-.39c-3.75-.86-5.72-5.23-5.44-6.69zm-21.25-16.6a2.91 2.91 0 00-.15 5.44c.86.54.87 1.24 0 1.55a3.82 3.82 0 00-1.73 2.13c-.07.42.74 1.24 1.82 1.82s1 .92-.21.76a3.51 3.51 0 00-2.82 1.42 2.61 2.61 0 00.53 2.12c.5.72.18 1.23-.71 1.15s-2.6 1.06-3 1.48 0 2.79.93 5.27.09 3.07-1.85 1.29-5.88-2.23-6.85-2a2.67 2.67 0 00-1.75 2.58c0 1.18-.52 1.22-1.16.09l-.64-1.13a4.1 4.1 0 00-.76-.92c-2.16 0-4.14-.15-6.57-.32l-.53 1c-.53 1-1 .83-1-.45a5.37 5.37 0 00-1.3-3.14c-.35-.24-1.91.67-3.46 2s-2 .94-1-.91a7.68 7.68 0 00-.07-5.74c-.44-.7-1.93-.88-3.29-.39s-1.6 0-.52-1.17 1.42-3.93 1.3-4.67-1.13-1.35-2.24-1.35-1.13-.56 0-1.23 2.23-3.38 2.43-4.16-1.17-2.17-3-3.07-1.6-1.54.6-1.41 5.77-2.38 6.63-3.22a3.77 3.77 0 001-3.32c-.3-1 .2-1.33 1.1-.76s3.18.24 3.8 0a2.8 2.8 0 001.13-2.5c0-1.15.47-1.26 1-.26a4.05 4.05 0 002.64 1.63c.45 0 1.28-1.16 1.86-2.51s1.47-1.27 2 .17 3.77 3.48 4.75 4 2.7-.2 3.84-1.58 1.66-1 1.15.89 1.22 5.77 1.84 6.83a4.35 4.35 0 003.9 1.66c1.54-.1 1.7.3.36.93z" data-name="Hole 1"/><path fill="currentColor" d="M185.51 76.49l-10.72-7a2.71 2.71 0 01-.65-4l6.59-8.32c1-1.3.52-2.21-1.12-2l-9.77 1c-1.64.17-2-.56-.68-1.61l6-4.91A1 1 0 00174 48.1L163.6 53a2.15 2.15 0 01-3.2-1.69l-1.75-10.9c-.27-1.63-1.5-2.07-2.74-1l-8.51 7.45a2.31 2.31 0 01-3.7-.66l-.38-.7c-.79-1.45-2-2.76-2.79-2.91s-2.17.81-3.16 2.13l-1.28 1.72a2.12 2.12 0 01-3.59 0l-5.66-7.66a2.11 2.11 0 00-3.58 0l-12.68 16.87a1.89 1.89 0 01-3.36-.16L94.59 34.57c-.86-1.41-1.26-1.25-.89.36l6.3 27.8a5.36 5.36 0 01-1.64 4.84l-5.16 4.3a10.64 10.64 0 01-4.75 2.19c-1.34.15-1.58 1.31-.52 2.58l1.59 1.9a14.9 14.9 0 012.57 5.24l2 8.8a12.19 12.19 0 002.78 5l.09.09a3 3 0 010 4.25l-4.44 4.44c-1.16 1.17-.8 2.43.8 2.81l5.68 1.39a7.07 7.07 0 014.29 10.76l-1.52 2.32a2.63 2.63 0 002.61 4l13-2.07a2.82 2.82 0 013 3.89l-3 7a1.68 1.68 0 002.69 1.89l7.71-7.17a12.37 12.37 0 015.14-2.61l10.93-2.12a5 5 0 014.64 1.91l3.67 5.36c.93 1.36 1.87 1.13 2.08-.5l.86-6.54a16.5 16.5 0 012-5.52l3.9-6.3a3.36 3.36 0 014.26-1.21l3.32 1.66c1.48.74 2.48 0 2.24-1.62l-2.37-15.78a2 2 0 012.51-2.42l11.47 2.15c1.62.31 1.93-.33.69-1.42l-9.06-8c-1.24-1.09-1-2.35.63-2.81l1.83-.52c1.59-.45 1.58-1.18 0-1.61 0 0-3.07-.84-3.62-1.39-1.21-1.21 12.24-3.33 12.24-3.33 1.55-.21 1.75-1.16.37-2.07zm-28.21 8.93c-1.86.94-3.74 5.11-4.14 6.37a4.68 4.68 0 001.46 4.3c1.21 1.11 1 1.53-.46.92a4.41 4.41 0 00-4 .87 4.34 4.34 0 00-.44 2.91c.18 1.07-.37 1.59-1.22 1.13a4.09 4.09 0 00-2.94.15c-.39.24-.46 1.48-.15 2.75s0 1.45-.76.39a3.74 3.74 0 00-3.15-1.24 2.78 2.78 0 00-1.32 2c-.21.91-.86 1-1.43.25s-2.71-1.31-3.34-1.34-2.22 2-3.55 4.52-2.38 2.28-2.35-.55-2.43-6.3-3.31-6.9a2.86 2.86 0 00-3.32.44c-1 .85-1.35.46-.91-.86a12.61 12.61 0 00.7-2.52l-.06-.07-1.55-1.73c-1.06-2.2-2.07-4.5-2.25-5.1s-.56-2.27-.62-2.71-1.89-1-4.08-1.32-2.2-.94 0-1.48 4.29-3.3 4.53-4.17-.68-2.17-2.05-2.91-1.11-1.3.57-1.26 4.15-1.68 4.66-2.31a25.14 25.14 0 011.88-2.05 31.32 31.32 0 013.62-2.65c.77-.41.89-2.49.27-4.64s.08-2.38 1.56-.52 6 2.9 7.32 3a4 4 0 003.39-1.57c.57-.94 2-.43 3.16 1.13s2.85 2.18 3.77 1.36 1.34-.53.95.65a4.29 4.29 0 00.59 3.28c.34.33 1.84.19 3.33-.32s2.08.26 1.3 1.72-.07 5.51.22 6.65 2.1 2 4 1.94 1.97.55.12 1.49z" data-name="Hole 2"/><path fill="currentColor" d="M117.52 172.68c.06-.47-4-4.94-4-4.94-3.69-4.07-3.74-7.23-.11-7s6.52 0 6.42-.4-3-1.6-6.42-2.61-5.84-5.6-4-8.14a6 6 0 00-4-9.18s-12.45-2.53-13.3-3.17-5.77-15.21-7.21-15-11.77 8.46-16.18 10l-4.11 1.39c-2.61 1.29-6.05.86-7.64-1s-2.91-3.28-3.2-1.75-3 3.46-4.86 1.09l-.57-2.75-.56-2.75c-2.16-2.09-4.25.69-4.66 6.18a103.16 103.16 0 01-2.55 15.23c-.53 2.11-2 4.76-4.11 4a4.11 4.11 0 01-1.77-1.62l-1.51-2.07c-2.29-4-4.36-7.14-4.59-7.06s.57 4.54 1.8 9.91c0 0 .34 1.51-1.64 6.83l-.89 2.4c-2.59.65-4.31 2.77-3.82 4.69l1.45 1.09c1.46 1.09 3.18 1.87 4.33 3.28s1.44 3.79 0 4.86c-2.38 1.74-2.17 5.59-.35 7.91s4.71 3.47 7.46 4.53c1 .37.79 1.76.44 2.73l-1.23 3.44c-1.36 3.78-.41 7 2.1 7.11s8.36 4.21 7.72 7.3 1 10.27 4.66 9 16.28-4.79 20.81-3.28l3.07-2.52c1.82-1.49 1.94-5.48 4-6.5 3.09-1.5 7.81 1.64 9.85 4.4s2.65 6.32 3.28 9.69c.32 1.81 3 2.28 4.46 1.21S99.3 212 99.3 212c1.48-5.3 3.94-8.68 5.46-7.53s4.08-.06 2.31-5.27a42.23 42.23 0 01-2-13.69c.29-5.36 12.35-12.09 12.45-12.83zM85.84 178c.62 1.17.13 1.89-1.08 1.61a4.37 4.37 0 00-3.61.84c-.77.74-2.73 3.42-2.29 4.83s-.3 1.52-1.64.22-3.21-2-4.17-1.55-4.37 1.74-5 3.09-1 1.3-.91-.12-.31-2.69-.89-2.83a26.72 26.72 0 01-3.37-1.38c-.73-.38-1.6-.9-2-1.14a3.68 3.68 0 00-3 .22c-1 .63-1.24.4-.55-.53s1-2 .67-2.34a4.46 4.46 0 00-2.58-1.24c-.84.09-1.12-.42-.64-1.13a2.85 2.85 0 00.5-2.25 8.73 8.73 0 00-2.72-3.09c-1.15-.62-1.25-1.59-.22-2.15a4.21 4.21 0 002-2.72 27.69 27.69 0 011.27-4.41c.27-.59.49-1.09.51-1.12s-.06-1.82-.19-3.91l-.05-.33 3.35-.72c1.83-.38 3.45-1.29 3.59-2s1.25-1.12 2.46-.88a4.66 4.66 0 003-.2c.46-.35 2.3-1.43 2.53-2.81s.77-1.32 1.23.11 1.39 2.75 2.08 2.9a27.51 27.51 0 013.53 1.37 21.37 21.37 0 012.22 1.39 5.7 5.7 0 005.1-.24c1.63-1.15 2-.63.9 1.16s-1.79 3.79-1.44 4.42 1.8 3.38 2.77 3.59 1.18 1.44.47 2.73-.72 3.94.24 4.47.84 1-.27 1-2.18.55-2.38 1.19a7.1 7.1 0 00.58 3.95z" data-name="Hole 3"/></g></g></svg>
        <h1>Bulletproof</h1>
        <div class="subtitle">I Wish I Was...</div>
      </figure>

      <div class="invitation">
        <div v-if="!isMobile" class="drop-prompt">
          Drop font files to start
        </div>
        <div v-if="!isMobile">or</div>
        <div class="request-font">
          <UiTextbox class="font-url-input" v-model="addFontUrl" placeholder="Enter font file URL (TTF, OTF, WOFF)" @keydown.enter="requestFont"></UiTextbox>
          <UiButton @click="requestFont" :disabled="!addFontUrl">Load</UiButton>
        </div>
        <div v-if="isMobile">or</div>
        <UiButton v-if="isMobile" @click="expandMenu('navMenu')">Just look around</UiButton>
      </div>

    </div>
    <WelcomeText class="readme" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import WelcomeText from "@/views/Welcome.md";
import UiButton from "keen-ui/src/UiButton.vue";
import UiTextbox from "keen-ui/src/UiTextbox.vue";

export default {
  name: "Welcome",
  components: {
    WelcomeText,
    UiButton,
    UiTextbox,
  },
  props: {},
  computed: {
    ...mapState([
      "isMobile",
      "remoteFontRequested",
    ]),
  },
  data() {
    return {
      addFontUrl: '',
    }
  },
  mounted() {
    this.$store.commit("scrollToTop");
  },
  methods: {
    expandMenu(menuId) {
      this.$store.commit("expandMenu", { menuId });
    },
    requestFont() {
      this.$store.commit("requestFont", { url: this.addFontUrl });
      this.addFontUrl = '';
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/variables";
@import "@/scss/mixins";

.welcome {
  .banner {
    font-size: 6rem;
    text-align: center;
    margin: 4vw 0 2rem;
    font-size: 4vw;
    @media (max-width: 800px) {
      font-size: 0.04 * 800px;
    }
    .logo {
      height: 4em;
      margin: -1em 0 -0.6em;
      max-width: 100%;
    }
    h1 {
      font-size: 1em;
      margin: 0;
      line-height: 1;
    }
    .subtitle {
      font-style: italic;
      font-size: 0.33em;
      position: relative;
      left: 4.75em;
    }
  }

  .invitation {
    text-align: center;
    color: #aaa;
  }

  .fold {
    margin-bottom: 5vw;
    text-align: center;
    @media (max-width: 1000px) {
      margin-bottom: 60px;
    }
  }
  .ui-button {
    background: #ddd;
    &:hover {
      background: #e2e2e2 !important;
    }
    margin-top: 1rem;
    padding: .8rem 3.5rem;
    @media (max-width: 500px) {
      padding: .8rem .5rem;
      font-size: .8rem;
    }
    height: unset !important;
  }

  .readme {
    margin: 20px 0 360px;
    @media (max-width: 1000px) {
      margin: 20px 0 100px;
    }
  }
  .drop-prompt {
    border: 5px dashed #ddd;
    border-radius: 1rem;
    padding: 4vw 2rem;
    margin: 3rem auto 3rem;
  }
  .request-font {
    margin: 1.5rem auto 1rem;
    display: flex;
    align-items: flex-end;
    .ui-textbox {
      flex: 1;
      margin-right: .8rem;
      @media (min-width: 1000px) {
        margin-left: 8rem;
      }
      .ui-textbox__input {
        text-align: center;
        font-size: .9em;
        @media (max-width: 500px) {
          font-size: .8rem;
        }
        padding-bottom: .3rem;
      }
    }
  }
}
</style>
